export const SSO_ALLOWED_EMAILS = [
  "k.saroj@serrala.com",
  "t.kotlapure@serrala.com",
  "tkotlapure@payference.ai",
  "a.chouhan@serrala.com",
  "s.halder@serrala.com",
  "vikas@payference.com",
  "vikas+proddemo@payference.com",
  "prashant+signature@payference.com",
  "prashant+1@payference.com",
  "vikas.panwar@serrala.com",
  "prashant.kumar@serrala.com",
  "r.pawar1@serrala.com",
  "m.khandelwal@serrala.com",
  "sandeep.rajoria@serrala.com",
  "sandeep.rajoria@payference.com",
  "u.kumar@serrala.com",
  "u.kumar@payference.com",
  "achitalia@payference.ai",
  "rpawar@payference.com",
  "uttamdbg@gmail.com",
  "p.khanna@serrala.com",
  "v.hande@serrala.com",
  "J.Eberhardt@serrala.com",
  "R.Hilgert@serrala.com",
  "L.AlMasri@serrala.com",
  "L.Deiri@serrala.com",
  "v.hande+edprod@serrala.com",
  "v.hande+naprod@serrala.com",
  "j.eberhardt@serrala.com",
  "r.hilgert@serrala.com",
  "k.saroj+dev-user@serrala.com",
  "t.kotlapure+dev-user@serrala.com",
];
